import {Alert, Tabs, Space, Spin} from "antd";
import {useCustomerUpcomingEvents} from "../../features/customer-live-events";
import {StyledNoUpcomingCallBox} from "../calls/upcoming-calls/upcoming-calls.style";
import {FullPageLoader} from "../full-page-loader";
import {UpcomingClassesCustomer} from "../live-classes/upcoming-classes/customer/upcoming-classes";
import {LoadingSpinner} from "../icons/icons";
import {StyledPageHeader} from "../../styles/dashboard/calls/calls";
import {useEffect, useState} from "react";
import {useGetCustomerUpcomingCallsContext} from "../../context/upcoming-calls/customer";
import {CustomerUpcomingCallCard} from "../calls/upcoming-calls/call-card/customer/new";
import {CustomerStorePageEntryPoint} from "../../pages/dashboard/customer/products";
import {useNavigate, useSearchParams} from "react-router-dom";

export const CustomerUpcomingEvents = () => {
  const {
    state: {
      customerUpcomingCallsData: {session},
      isFetchingCustomerUpcomingCalls,
    },
  } = useGetCustomerUpcomingCallsContext();
  const getLiveClassesQuery = useCustomerUpcomingEvents({page: 1, perPage: 5});
  const liveEvents = getLiveClassesQuery.data?.data ?? [];

  if (getLiveClassesQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (
    getLiveClassesQuery.isError &&
    getLiveClassesQuery.error.message !==
      "Sorry, You currently do not have any live events!"
  ) {
    return (
      <Alert
        message="Error"
        description={getLiveClassesQuery.error.message}
        type="error"
        showIcon
      />
    );
  }

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="All" key="1">
          {(liveEvents.length < 1 && session.length < 1) || !getLiveClassesQuery.data ? (
            <StyledNoUpcomingCallBox>
              <p className="info-text">You do not have upcoming events at the moment.</p>
            </StyledNoUpcomingCallBox>
          ) : (
            <>
              <Spin
                spinning={
                  getLiveClassesQuery.isFetching || isFetchingCustomerUpcomingCalls
                }
                tip="Updating..."
                indicator={LoadingSpinner}
              >
                <Space direction="vertical" size={42} style={{display: "flex"}}>
                  {session.map((call) => (
                    <CustomerUpcomingCallCard key={call.id} session={call} />
                  ))}
                  {liveEvents.length > 0 && (
                    <UpcomingClassesCustomer events={liveEvents} />
                  )}
                </Space>
              </Spin>
            </>
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="1:1 Sessions" key="2">
          {session.length > 0 ? (
            <Space direction="vertical" size={42} style={{display: "flex"}}>
              {session.map((call) => (
                <CustomerUpcomingCallCard key={call.id} session={call} />
              ))}
            </Space>
          ) : (
            <StyledNoUpcomingCallBox>
              <p className="info-text">
                You do not have upcoming sessions at the moment. Book a new session to get
                started
              </p>
            </StyledNoUpcomingCallBox>
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Live events" key="3">
          <Spin
            spinning={getLiveClassesQuery.isFetching}
            tip="Updating..."
            indicator={LoadingSpinner}
          >
            <UpcomingClassesCustomer events={liveEvents} />
          </Spin>
        </Tabs.TabPane>
      </Tabs>

      <div style={{marginTop: "4rem"}}>
        <CustomerDashboardHomeStoreSection />
      </div>
    </div>
  );
};

export function CustomerDashboardHomeStoreSection() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<
    "digital-products" | "services" | "subscriptions"
  >("services");
  const navigate = useNavigate();

  useEffect(() => {
    if (
      activeTab === "digital-products" ||
      activeTab === "services" ||
      activeTab === "subscriptions"
    ) {
      setDefaultActiveKey(activeTab);
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "digital-products") {
      setDefaultActiveKey("digital-products");
      navigate("/customer/products?activeTab=digital-products");
    }
    if (key === "services") {
      setDefaultActiveKey("services");
      navigate("/customer/products?activeTab=services");
    }
    if (key === "subscriptions") {
      setDefaultActiveKey("subscriptions");
      navigate("/customer/products?activeTab=subscriptions");
    }
  }
  return (
    <>
      <StyledPageHeader>Store</StyledPageHeader>
      <div style={{marginTop: "4.6rem"}}>
        <CustomerStorePageEntryPoint
          defaultActiveKey={defaultActiveKey}
          handleTabClick={handleTabClick}
        />
      </div>
    </>
  );
}
